import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Global/Dropdowns/Dropdown';
import DropdownSection from '../Global/Dropdowns/DropdownSection';
import Button from '../Global/Buttons/Button';
import IconWithText from '../Global/Icons/IconWithText';
import FavouriteButton from '../Global/Buttons/FavouriteButton';
import AddToFolderButton from '../Global/Buttons/AddToFolderButton';

const SessionActions = ({ loggedInUser, favourited, favouriteClick, printClick, folderClick }) => {
  const printBtn = <Button onClick={printClick} classes="print-session-btn" faux><IconWithText name="print" size="m" fill="white">Print</IconWithText></Button>;

  return (
    <div className="session-actions fw-medium">
      <ul>
        <li>
          <Dropdown size="s" label={printBtn}>
            <DropdownSection><Button onClick={() => printClick('compact')} classes="dropdown-link" faux>Compact layout</Button></DropdownSection>
            <DropdownSection><Button onClick={() => printClick('detailed')} classes="dropdown-link" faux>Detailed layout</Button></DropdownSection>
            <DropdownSection><Button onClick={() => printClick('current')} classes="dropdown-link" faux>Current practice only</Button></DropdownSection>
          </Dropdown>
        </li>
        <li><FavouriteButton favourited={favourited} onClick={favouriteClick} iconFill="white" loggedInUser={loggedInUser} /></li>
        <li><AddToFolderButton onClick={folderClick} loggedInUser={loggedInUser} iconFill="white" /></li>
      </ul>
    </div>
  );
};

SessionActions.propTypes = {
  loggedInUser: PropTypes.object,
  favourited: PropTypes.bool.isRequired,
  favouriteClick: PropTypes.func.isRequired,
  printClick: PropTypes.func,
  folderClick: PropTypes.func,
};

export default SessionActions;



// WEBPACK FOOTER //
// ./library/app/components/Session/SessionActions.js